// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-carousel .alice-carousel {
    width: 80% !important;
    height: 40px !important;
}

.custom-carousel .alice-carousel__stage-item {
    padding-left: 2px;
}

.custom-segmented .ant-segmented-item-selected {
    background-color: rgb(110, 125, 171) !important; /* Active button background */
    color: white !important; /* Active text color */
  }`, "",{"version":3,"sources":["webpack://./src/components/Checklist/Slide.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+CAA+C,EAAE,6BAA6B;IAC9E,uBAAuB,EAAE,sBAAsB;EACjD","sourcesContent":[".custom-carousel .alice-carousel {\n    width: 80% !important;\n    height: 40px !important;\n}\n\n.custom-carousel .alice-carousel__stage-item {\n    padding-left: 2px;\n}\n\n.custom-segmented .ant-segmented-item-selected {\n    background-color: rgb(110, 125, 171) !important; /* Active button background */\n    color: white !important; /* Active text color */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
